import { Usuario } from './usuario.model';
/**
 * Propiedades comunes entre módelos de este archivo.
 *
 * @class Base
 */
export class Base {
  id?: number;
  nombre: string;
  descripcion: string;
}

/**
 * Módelo base con las propiedades necesarias.
 *
 * @export
 * @class RolDefault
 * @extends {Base}
 */
export class RolDefault extends Base {
  activo: boolean;
  rol_empresa: number | Base;
  permisos: Array<number>;
}

/**
 * Grupo con privilegios en el sistema que se asigna a un usuario.
 *
 * @export
 * @class Rol
 */
export class Rol extends RolDefault {
  rol_user: Usuario[];
}

/**
 * Rol con las propidades básicas y un resumen de la
 * cantidad de usuarios vinculados al mismo.
 *
 * @export
 * @class RolUser
 * @extends {RolDefault}
 */
export class RolUsers extends RolDefault {
  cantidad_usuarios: number;
}

/**
 * Modelo de la consulta de los permisos de los roles(Grupos)
 *
 * @export
 * @class RolPermisos
 */
export class RolPermisos {
  id: number;
  nombre: string;
  permisos: Array<PermisoRol>;
}

/**
 * Modelo complementario de un permiso de un rol
 *
 * @export
 * @class PermisoRol
 */
export class PermisoRol {
  id: number;
  id_permiso: number;
  nombre: string;
  id_tipo_permiso: number;
  tipo_permiso: string;
}

/**
 * Modleo de la consulta de permisos por tipo
 *
 * @export
 * @class PermisoPorTipo
 * @extends {Base}
 */
export class PermisoPorTipo extends Base {
  permisos: Array<PredeterminadoPermisoRol>;
}

/**
 * Modelo complementario de los permisos asociados a un tipo de permiso
 *
 * @export
 * @class PredeterminadoPermisoRol
 * @extends {Base}
 */
export class PredeterminadoPermisoRol extends Base {
  id_permiso: number;
}

/**
 * Modelo de la consulta de los grupos asociados a un tramite
 *
 * @export
 * @class TramiteRol
 */
export class TramiteRol {
  id: number;
  tramite_default: number;
  rol: RolTramite;
  inicio_tramite: boolean;
}

/**
 * Modelo complementario de el rol(grupo) asociado a un tramite
 *
 * @export
 * @class RolTramite
 */
export class RolTramite {
  id_rol: number;
  nombre: string;
}

/**
 * Modelo para asociar un Rol(Grupo) a un tramite
 *
 * @export
 * @class RolTramiteDefaul
 */
export class RolTramiteDefaul {
  rol: number;
  tramite_default: number;
  inicio_tramite: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/rol.model.ts